import Services from './base-services'

const service = new Services('mdDiagnostico')

export default {
    findDiagnosticoPendiente(userId:any, isFinished: boolean = false) {
        return service.get(`findDiagnosticoPendiente?userId=${userId}&isFinished=${isFinished}`)
    },
    getDiagnostic(diagnosticId: number, userId?: number) {
        const params = userId ? `diagnosticId=${diagnosticId}&userId=${userId}` : `diagnosticId=${diagnosticId}`
        return service.get(`getDiagnostic?${params}`)
    },
    answerDiagnostico(data: any) {
        return service.post(`answerDiagnostico`, data)
    },
}
